import baseService from '@common/services/base.service';
import store from '@common/store/store';

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const ssRoute = window.api_routes.smarAPD_SS_Domain;

let httpTB = baseService(store, tbRoute);
let httpSS = baseService(store, ssRoute);

const apiDef = {
  saveTB(data) {
    return httpTB.post(`/SelecaoItemExterno`, data);
  },
  getIdsSelecionados(idSelecao) {
    return httpTB.get(`/SelecaoItemExterno/GetIdsSelecionados/${idSelecao}`);
  },
  saveSST(data) {
    return httpSS.post(`/relatorio/GenerateIdSelecao`, data);
  },
};

export default apiDef;
